import { NODES } from '../../../entities/tree/config';
import getIconVehicle from '../../../shared/ui/getIconVehicle';

export function generateTreeNodes(key, data) {
  const accessToken = window.localStorage.getItem('token') || window.sessionStorage.getItem('token');

  return data.map((item, i) => ({
    data: item.data ? { ...item.data } : { ...item },
    title: `${item.title || item.name}`,
    key: item.key || `${key}-${i}`,
    nodeType: item.nodeType,
    icon: getIconVehicle({
      token: accessToken,
      type: item.nodeType,
      modelId: item?.model?.vehicleModelId,
      color: item?.customAugmentationEx?.view?.['icon-color'],
    }),
    isLeaf:
      item.nodeType === NODES.USER.TYPE ||
      item.nodeType === NODES.VEHICLE.TYPE ||
      item.nodeType === NODES.PASSENGERS.TYPE ||
      item.nodeType === NODES.CARGO.TYPE,
  }));
}

export function getNewTreeData(treeData, curKey, child) {
  const loop = (data) => {
    data.forEach((item) => {
      if (curKey.indexOf(item.key) === 0) {
        if (item.children) {
          loop(item.children);
        } else {
          // eslint-disable-next-line no-param-reassign
          item.children = child;
        }
      }
    });
  };
  loop(treeData);
}

// проверяет вхождение key
const isKeyIncluded = (key1, key2) => {
  const subKeys1 = key1.split('-');
  const subKeys2 = key2.split('-');
  let i = 0;
  while (i < subKeys2.length && subKeys1[i] === subKeys2[i]) {
    i += 1;
  }
  return i === subKeys2.length;
};

// Возвращает узел из дерева по kurKey
export const getNode = (tree, kurKey) => {
  const loop = (data) => {
    for (let i = 0; i < data.length; i += 1) {
      if (isKeyIncluded(kurKey, data[i].key)) {
        if (data[i].key === kurKey) {
          return data[i];
        }
        if (data[i].children) {
          return loop(data[i].children);
        }
      }
    }
    return null;
  };
  return loop(tree);
};

// Возвращает адресную строку для выбранного узла дерева
export const getUrlForNode = (openNodes, tabs) => {
  const urls = [];
  const divisionsUrls = [];
  const vehiclesUrls = [];

  let tabUrl = '';
  openNodes.forEach((node) => {
    switch (node.nodeType) {
      case NODES.COMPANY.TYPE:
        urls.push(`companies/${node.data.id}`);
        tabUrl = tabs.company;
        break;
      case NODES.DIVISIONS.TYPE:
        urls.push(`divisions`);
        tabUrl = tabs.divisions;
        break;
      case NODES.DIVISION.TYPE:
        divisionsUrls.push(`${node.data.id}`);
        tabUrl = tabs.division;
        break;
      case NODES.VEHICLE.TYPE:
        vehiclesUrls.push(`vehicles/${node.data.id}`);
        tabUrl = tabs.vehicle;
        break;
      case NODES.USERS.TYPE:
        urls.push(`users`);
        tabUrl = tabs.users;
        break;
      case NODES.USER.TYPE:
        urls.push(`${node.data.id}`);
        tabUrl = tabs.user;
        break;
      case NODES.PASSENGERS.TYPE:
        urls.push(`passengers`);
        tabUrl = tabs.passengers;
        break;
      case NODES.CARGO.TYPE:
        urls.push(`cargo`);
        tabUrl = tabs.cargo;
        break;
      case NODES.CLIENTS.TYPE:
        urls.push(`clients`);
        tabUrl = tabs.clients;
        break;
      case NODES.CLIENT?.TYPE:
        urls.push(`${node.data.id}`);
        tabUrl = tabs.client;
        break;
      default:
        break;
    }
  });

  const divisionsUrl = divisionsUrls.length ? `/${divisionsUrls.join('-')}` : '';
  const vehiclesUrl = vehiclesUrls.length ? `/${vehiclesUrls.join('-')}` : '';

  return `/${urls.join('/')}${divisionsUrl}${vehiclesUrl}/${tabUrl}`;
};

// Заново устанавливает иконки для дерева
export function updateIcons(tree, isAdmin) {
  const accessToken = window.localStorage.getItem('token') || window.sessionStorage.getItem('token');
  return tree.map((node) => {
    const newNode = {
      ...node,
      icon: getIconVehicle({
        token: accessToken,
        type: node.nodeType,
        modelId: node?.data?.model?.vehicleModelId,
        customIcon: node?.data?.model?.icon,
        color: node?.data?.customAugmentationEx?.view?.['icon-color'],
        isDealerCompanyView: isAdmin && node?.data?.isDealer,
      }),
    };

    if (node.children && node.children.length) {
      newNode.children = updateIcons(node.children, accessToken);
    }

    return newNode;
  });
}
